const { Card, CardHeader, FlexItem, FlexBlock, ExternalLink } = wp.components;

const { __ } = wp.i18n;

function CardWithButton({
	content = __('Need help setting up?', 'conditional-blocks'),
	buttonUrl = 'https://conditionalblocks.com/docs/',
	buttonText = __('Go to docs', 'conditional-blocks')
}) {
	return (
		<div className='conditional-blocks-builder-modal__row'>
			<Card size='extraSmall'>
				<CardHeader>
					<FlexBlock className='conditional-blocks-small'>{content}</FlexBlock>
					<FlexItem>
						<ExternalLink className='conditional-blocks-small' href={buttonUrl}>
							{buttonText}
						</ExternalLink>
					</FlexItem>
				</CardHeader>
			</Card>
		</div>
	);
}

export default CardWithButton;
